// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__cnY3H","visa":"style_visa__2+C0+","discover":"style_discover__dzV4I","mastercard":"style_mastercard__cqmFX","amex":"style_amex__sqNBY"};